<!-- QR SCAN SCREEN -->
@if (showQrScreen) {

  <main class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

    <div class="bg-white rounded-3xl border border-slate-200/90
                shadow-[0_10px_35px_-4px_rgba(0,0,0,0.04)]
                px-6 py-8 sm:px-10 sm:py-10">

      <!-- Camera Preview -->
      <section
        class="bg-[#f8faff] border border-blue-100/70 rounded-2xl
               py-8 px-4 flex flex-col items-center justify-center mb-8">

        @if (isScanning) {

          <div id="qr-reader"
               class="w-full max-w-[400px]">
          </div>

          <p class="text-sm text-slate-500 mt-4">
            Show the QR code in front of the camera
          </p>

        } @else {

          <div class="relative w-16 h-16 mb-4 flex items-center justify-center">
            <svg
              class="w-12 h-12 text-[#1e3a8a]"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.5"
              viewBox="0 0 48 48">

              <path d="M 6 15 L 6 10 A 4 4 0 0 1 10 6 L 15 6"></path>
              <path d="M 33 6 L 38 6 A 4 4 0 0 1 42 10 L 42 15"></path>
              <path d="M 6 33 L 6 38 A 4 4 0 0 0 10 42 L 15 42"></path>
              <path d="M 33 42 L 38 42 A 4 4 0 0 0 42 38 L 42 33"></path>

              <circle cx="18" cy="18" fill="currentColor" r="1.75"></circle>
              <circle cx="30" cy="18" fill="currentColor" r="1.75"></circle>
              <circle cx="18" cy="30" fill="currentColor" r="1.75"></circle>
              <circle cx="24" cy="24" fill="currentColor" r="1.75"></circle>
              <circle cx="30" cy="30" fill="currentColor" r="1.75"></circle>

            </svg>
          </div>

          <p class="text-xs sm:text-sm font-medium text-slate-500">
            Camera Ready for Input
          </p>
        }

      </section>


      <!-- Content -->
      <section class="text-center">

        <h1 class="text-xl sm:text-2xl font-bold
                   text-slate-900 tracking-tight mb-3">
          Welcome to Your Exam
        </h1>

        <p class="text-xs sm:text-sm leading-relaxed
                  text-slate-500 max-w-sm mx-auto mb-7">
          Scan the QR code provided by the exam center to securely
          access your exam session.
        </p>


        <!-- Start QR Scan -->
        @if (!isScanning) {

          <div class="mb-3">

            <button
              type="button"
              (click)="startQrScan()"
              class="w-full bg-[#deebfc]
                     hover:bg-[#d2e3fb]
                     text-[#1e40af]
                     font-semibold text-sm sm:text-base
                     py-3 px-6 rounded-xl
                     transition-colors duration-150
                     shadow-sm">

              Start QR Scan

            </button>

          </div>

        } @else {

          <button
            type="button"
            (click)="stopQrScan()"
            class="w-full bg-red-100
                   hover:bg-red-200
                   text-red-700
                   font-semibold text-sm
                   py-3 px-6 rounded-xl">

            Stop Scanner

          </button>

        }


        <!-- Scan Result -->
        @if (scanMessage) {

          <div
            class="mt-5 p-3 rounded-xl text-sm"
            [class.bg-green-50]="scanSuccess"
            [class.text-green-700]="scanSuccess"
            [class.bg-red-50]="!scanSuccess"
            [class.text-red-700]="!scanSuccess">

            {{ scanMessage }}

          </div>

        }


        <!-- Booking ID Alternative -->
        <div class="mt-6">

          <p class="text-xs text-slate-400 mb-2">
            Don't have access to the QR scanner?
          </p>

          <button
            type="button"
            (click)="useBookingId()"
            class="text-sm font-semibold text-[#1e3a8a]
                   hover:text-blue-700
                   underline underline-offset-4">

            Use Booking ID instead

          </button>

        </div>

      </section>

    </div>

  </main>

}

@else {

  <main
    class="w-full max-w-[540px] mx-auto
           bg-white rounded-3xl border border-slate-100
           shadow-[0_4px_25px_rgba(0,0,0,0.05)]
           p-6 sm:p-10
           transition-all duration-200">

    <!-- Back Button -->
    <button
      type="button"
      (click)="backToQrScan()"
      class="mb-6 inline-flex items-center gap-2
             text-sm font-medium text-slate-500
             hover:text-[#1e3a8a]
             transition-colors">

      ← Back to QR Scan

    </button>


    <!-- Header -->
    <header class="flex flex-col items-center text-center">

      <div
        class="w-12 h-12 rounded-full
               bg-blue-50/80 border border-blue-100
               flex items-center justify-center
               mb-5 text-blue-600 shadow-sm">

        <svg
          class="w-6 h-6 stroke-[1.75]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">

          <path
            d="M9 12.75L11.25 15 15 9.75
               m-3-7.036A11.959 11.959 0 013.598 6
               A11.99 11.99 0 003 9.749
               c0 5.592 3.824 10.29 9 11.623
               5.176-1.332 9-6.03 9-11.622
               0-1.31-.21-2.571-.598-3.751"
            stroke-linecap="round"
            stroke-linejoin="round">
          </path>

        </svg>

      </div>


      <h1
        class="text-2xl sm:text-[28px]
               font-bold text-slate-900
               tracking-tight leading-snug">

        Welcome to Your Examination

      </h1>


      <p
        class="text-slate-500 text-sm sm:text-base
               mt-2 max-w-[420px]
               font-normal leading-relaxed">

        Enter your Booking ID and Date of Birth to securely
        access your examination.

      </p>

    </header>


    <!-- Form -->
    <form class="mt-8 space-y-5">

      <!-- Booking ID -->
      <div>

        <label
          for="bookingId"
          class="block text-sm font-semibold
                 text-slate-700 mb-1.5">

          Booking ID

        </label>


        <input
          id="bookingId"
          type="text"
          [(ngModel)]="bookingId"
          name="bookingId"
          placeholder="Enter your Booking ID"
          class="block w-full px-4 py-3
                 bg-white border border-slate-200
                 rounded-xl text-slate-900
                 placeholder-slate-400 text-sm
                 focus:outline-none
                 focus:border-blue-600
                 focus:ring-2
                 focus:ring-blue-100">

      </div>


      <!-- DOB -->
      <div>

        <label
          for="dob"
          class="block text-sm font-semibold
                 text-slate-700 mb-1.5">

          Date of Birth

        </label>


        <input
          id="dob"
          type="date"
          [(ngModel)]="dob"
          name="dob"
          class="block w-full px-4 py-3
                 bg-white border border-slate-200
                 rounded-xl text-slate-900 text-sm
                 focus:outline-none
                 focus:border-blue-600
                 focus:ring-2
                 focus:ring-blue-100">

      </div>


      <!-- Security Notice -->
      <aside
        class="bg-blue-50/70 border border-blue-100/70
               rounded-xl px-4 py-3
               flex items-center gap-2.5">

        <span class="text-xs sm:text-sm text-blue-900">

          Your examination session is secure and monitored.

        </span>

      </aside>


      <!-- Start Exam -->
      <button
        type="button"
        (click)="startExamWithBookingId()"
        [disabled]="!bookingId || !dob"
        class="w-full py-3.5 px-4
               bg-[#1e3a8a]
               hover:bg-blue-900
               disabled:bg-slate-400
               disabled:cursor-not-allowed
               text-white font-medium text-base
               rounded-xl transition">

        Start Exam

      </button>


      <footer class="pt-1 text-center">

        <p class="text-xs text-slate-500">

          Use the Booking ID provided on your examination admit card.

        </p>

      </footer>

    </form>

  </main>

}


<!-- Toast -->
@if (showToastMessage) {
  <div class="fixed top-6 left-1/2 -translate-x-1/2 z-50">

    <div
      class="flex items-center gap-3
             bg-white border border-green-200
             text-green-700
             px-5 py-3 rounded-xl
             shadow-lg">

      <span
        class="flex items-center justify-center
               w-6 h-6 rounded-full
               bg-green-100">
        ✓
      </span>

      <span class="text-sm font-semibold">
        {{ toastMessage }}
      </span>

    </div>

  </div>
}


<!-- 1 Second Loading Overlay -->
@if (isLoading) {
  <div
    class="fixed inset-0 z-40
           bg-black/20 backdrop-blur-[2px]
           flex items-center justify-center">

    <div
      class="bg-white rounded-2xl
             px-8 py-7 shadow-xl
             flex flex-col items-center">

      <div
        class="w-10 h-10
               border-4 border-blue-100
               border-t-[#1e3a8a]
               rounded-full animate-spin">
      </div>

      <p class="mt-4 text-sm font-semibold text-slate-700">
        Preparing your examination...
      </p>

    </div>

  </div>
}
